import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuthUser } from '../types/auth';
import { acceptOtp } from '../utils/mockOtp';
import { generateMockWallet } from '../utils/generateId';
import { wait } from '../utils/wait';

type AuthState = {
  user: AuthUser | null;
  pendingEmail: string | null;
  isRequesting: boolean;

  requestOtp: (email: string) => Promise<void>;
  confirmOtp: (code: string) => Promise<boolean>;
  logout: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      pendingEmail: null,
      isRequesting: false,

      async requestOtp(email) {
        set({ isRequesting: true });
        await wait(600);
        set({ pendingEmail: email, isRequesting: false });
      },

      async confirmOtp(code) {
        if (!acceptOtp(code)) return false;
        const email = get().pendingEmail;
        if (!email) return false;
        await wait(400);
        const user: AuthUser = {
          email,
          walletAddressMock: generateMockWallet(email),
          loginAt: new Date().toISOString(),
        };
        set({ user, pendingEmail: null });
        return true;
      },

      logout() {
        set({ user: null, pendingEmail: null });
      },
    }),
    {
      name: 'tt:auth',
      version: 1,
      partialize: (state) => ({ user: state.user }),
      onRehydrateStorage: () => (state, error) => {
        if (error) {
          console.warn('Falha ao rehidratar tt:auth — limpando.', error);
          try {
            localStorage.removeItem('tt:auth');
          } catch {
            // ignore
          }
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        state;
      },
    },
  ),
);
